import React from 'react';
import { ASSETS } from '../constants/assets';
import './BackButton.css';

interface BackButtonProps {
  className?: string;
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ className, onClick }) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.currentTarget.blur();
    onClick();
  };

  return (
    <button
      type="button"
      className={`app-back-button${className ? ` ${className}` : ''}`}
      aria-label="Înapoi"
      onClick={handleClick}
    >
      <img src={ASSETS.BACK_ARROW} alt="" aria-hidden="true" />
    </button>
  );
};

export default BackButton;
